import { render, staticRenderFns } from "./FileUploadForTask.vue?vue&type=template&id=2aa5ebe4"
import script from "./FileUploadForTask.vue?vue&type=script&lang=js"
export * from "./FileUploadForTask.vue?vue&type=script&lang=js"
import style0 from "./FileUploadForTask.vue?vue&type=style&index=0&id=2aa5ebe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports